import { render, staticRenderFns } from "./VideoRecording.vue?vue&type=template&id=e6b1261a&scoped=true&"
import script from "./VideoRecording.vue?vue&type=script&lang=js&"
export * from "./VideoRecording.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecording.vue?vue&type=style&index=0&id=e6b1261a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b1261a",
  null
  
)

export default component.exports